import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../../../../core/auth/auth.service';

export const headerResolver: ResolveFn<void> = () => {
  const authService = inject(AuthService);
  return authService.refreshAccount();
};
